module.exports = __webpack_public_path__ + "static/media/about1.78437bc3.png";